import React, { FC } from 'react';
import style from 'app/modules/mediaLibrary/components/mediaLibraryModal/albumSelect/Placeholder.module.scss';
import AlbumItem from 'app/modules/mediaLibrary/components/mediaLibraryModal/albumSelect/AlbumItem';
import { MediaLibraryAlbum } from 'types/MediaLibrary';
import { Icon } from '@kontentino/ui';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import { useTranslation } from 'react-i18next';
type Props = {
  onClick: () => void;
  album?: MediaLibraryAlbum;
};

const Placeholder: FC<Props> = ({ onClick, album }) => {
  const { t } = useTranslation();
  return (
    <div className={style.button} tabIndex={0} onClick={onClick}>
      {album && <AlbumItem album={album} />}
      {!album && (
        <div className={style.label}>
          {t('mediaLibrary.selectAlbumPlaceholder')}
        </div>
      )}
      <Icon icon={faChevronDown} marginLeft="auto" />
    </div>
  );
};

export default Placeholder;
